import is from '@sindresorhus/is';
import type { MouseEvent } from 'react';

const ROW_ACTIVATION_ATTRIBUTE = 'data-row-activation';

export const rowActivationIgnoredAttrs = { [ROW_ACTIVATION_ATTRIBUTE]: 'ignore' } as const;

const INTERACTIVE_CONTROL_SELECTOR = `button, [role="button"], [${ROW_ACTIVATION_ATTRIBUTE}="ignore"]`;

const hasTextSelectionInside = (row: Element): boolean => {
    const selection = window.getSelection();
    if (is.null(selection) || selection.isCollapsed || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    return row.contains(range.startContainer) || row.contains(range.endContainer);
};

export const isRowActivationClick = (event: MouseEvent<HTMLElement>): boolean => {
    const { currentTarget, target } = event;
    if (!(target instanceof Element) || !currentTarget.contains(target)) return false;
    const control = target.closest(INTERACTIVE_CONTROL_SELECTOR);
    if (!is.null(control) && control !== currentTarget && currentTarget.contains(control)) return false;
    return !hasTextSelectionInside(currentTarget);
};
